import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { animations } from './animations';

@Injectable()
export class AnimationsService {

  private animations = animations;

  constructor() { }

  public getAllAnimations() {
    return this.animations;
  }

  public getAnimations(group: string) {
    let result = this.animations[group];
    return result;
  }

  public getAnimation(id: string) {
    // console.log(id);
    let animation = _.find(_.flatMap(this.animations), obj => obj['id'] === id);
    // console.log(animation);
    return animation;
  }

}



// WEBPACK FOOTER //
// ./src/app/animations/animations.service.ts